import React from 'react';
import { format } from 'date-fns';

interface DateRangePickerProps {
  dateFrom: Date | null;
  dateTo: Date | null;
  onDateFromChange: (date: Date | null) => void;
  onDateToChange: (date: Date | null) => void;
  disabled?: boolean;
  error?: string;
  required?: boolean;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  disabled = false,
  error,
  required = false
}) => {
  const todayStr = format(new Date(), 'yyyy-MM-dd');

  const handleDateFromChange = (date: Date | null) => {
    onDateFromChange(date);
    // Auto-set dateTo if not set or if dateTo is before new dateFrom
    if (date && (!dateTo || dateTo < date)) {
      onDateToChange(date);
    }
  };

  const handleDateToChange = (date: Date | null) => {
    onDateToChange(date);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-1">
          <label htmlFor="dateFrom" className="block text-sm font-medium text-gray-700">
            From Date {required && <span className="text-error-500">*</span>}
          </label>
          <input
            id="dateFrom"
            type="date"
            value={dateFrom ? format(dateFrom, 'yyyy-MM-dd') : ''}
            onChange={(e) => handleDateFromChange(e.target.value ? new Date(e.target.value) : null)}
            disabled={disabled}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-info-500 focus:border-info-500 transition-colors"
            max={todayStr}
          />
        </div>
        
        <div className="space-y-1">
          <label htmlFor="dateTo" className="block text-sm font-medium text-gray-700">
            To Date {required && <span className="text-error-500">*</span>}
          </label>
          <input
            id="dateTo"
            type="date"
            value={dateTo ? format(dateTo, 'yyyy-MM-dd') : ''}
            onChange={(e) => handleDateToChange(e.target.value ? new Date(e.target.value) : null)}
            disabled={disabled}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-info-500 focus:border-info-500 transition-colors"
            min={dateFrom ? format(dateFrom, 'yyyy-MM-dd') : undefined}
            max={todayStr}
          />
        </div>
      </div>
      
      {error && (
        <p className="text-error-600 text-xs animate-fadeIn">{error}</p>
      )}
      
      <div className="text-xs text-gray-500">
        Select the date range for this expense period
      </div>
    </div>
  );
};

export default DateRangePicker;
